module.exports = __webpack_public_path__ + "static/media/03.b5a76707.webp";